/**
 * AppealSlice Settings Reducers
 * 
 * Reducers for managing appeal settings and editing mode.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { TemplateType, AppealType, AppealStatus } from '../../types/appealTypes';
import { AppealSliceState } from '../state';

// =============================================================================
// SETTINGS REDUCERS
// =============================================================================

/**
 * Update appeal settings (template type, appeal type, status)
 */
export const updateAppealSettings: CaseReducer<
  AppealSliceState, 
  PayloadAction<{
    templateType?: TemplateType;
    appealType?: AppealType;
    status?: AppealStatus;
  }>
> = (state, action) => {
  if (state.currentAppeal) {
    if (action.payload.templateType !== undefined) {
      state.currentAppeal.templateType = action.payload.templateType;
    }
    if (action.payload.appealType !== undefined) {
      state.currentAppeal.appealType = action.payload.appealType;
    }
    if (action.payload.status !== undefined) {
      state.currentAppeal.status = action.payload.status;
    }
    state.hasUnsavedChanges = true;
  }
};

/**
 * Set whether the appeal is in editing mode
 */
export const setIsEditing: CaseReducer<AppealSliceState, PayloadAction<boolean>> = (
  state,
  action
) => {
  state.isEditing = action.payload;
};
